import { LogoMark } from "./Logo";

const LINKS = [
  { label: "Capitoli", target: "#capitoli" },
  { label: "Protocolli", target: "#protocolli" },
  { label: "Diagnostico", target: "#diagnostico" },
];

export default function Nav({ scrollTo }) {
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-ink/80 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-brand-logo"
          onClick={(e) => {
            e.preventDefault();
            scrollTo("#top");
          }}
          className="flex items-center gap-3"
        >
          <LogoMark />
          <span className="font-display font-bold tracking-[0.25em] text-white text-sm">
            NEVER BETTER
          </span>
        </a>
        <nav
          className="hidden md:flex items-center gap-8"
          data-testid="nav-link-chapters"
        >
          {LINKS.map((l) => (
            <button
              key={l.target}
              onClick={() => scrollTo(l.target)}
              className="text-xs font-mono uppercase tracking-[0.2em] text-[#858599] hover:text-white transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <span className="hidden sm:inline-flex items-center gap-2 text-[10px] font-mono uppercase tracking-[0.25em] text-emerald-400 border border-emerald-400/30 rounded-full px-3 py-1">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
            Accesso Aperto
          </span>
          <button
            data-testid="nav-cta-button"
            onClick={() => scrollTo("#diagnostico")}
            className="bg-neon text-black text-xs font-bold uppercase tracking-widest px-4 py-2 neon-shadow hover:bg-[#ff6a22] transition-colors"
          >
            Sblocca ➔
          </button>
        </div>
      </div>
    </header>
  );
}
